import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlService} from './url.service';
import {ScorecardKentuckyResult, ScorecardPeriodOption} from '../models/scorecard-kentucky.model';

/**
 * Fetches Kentucky Agency Scorecard data. One call returns BOTH the target OU (subtree rolled up) and its
 * parent -- parent resolution and the OU-eligibility clamp live server-side, so the caller only supplies the
 * target ouId + resolved period.
 */
@Injectable()
export class ScorecardKentuckyService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/v2/reports';
    }

    /**
     * The periods the scorecard can be run for, already resolved against today by the backend. Fetched rather
     * than computed here so the frontend never does period date arithmetic, and so the offered periods are
     * exactly the ones the ETL is configured to produce.
     */
    getPeriods(): Observable<ScorecardPeriodOption[]> {
        return this.http.get<ScorecardPeriodOption[]>(this.BASE_URL + '/scorecardKentuckyPeriods');
    }

    getScorecard(ouId: string, period: string): Observable<ScorecardKentuckyResult> {
        let params = new HttpParams();
        if (ouId) {
            params = params.set('ouId', ouId);
        }
        if (period) {
            params = params.set('period', period);
        }
        return this.http.get<ScorecardKentuckyResult>(this.BASE_URL + '/scorecardKentucky', {params});
    }
}
